<template>
  <EditHikeDetailsModal ref="modal" :hike="hike" @save="saveHikeDetails" />
</template>

<script setup>
// Standalone mount of the hikes-list "Edit Details" modal for the (server-rendered)
// hike overview page. Reuses the same EditHikeDetailsModal + UpdateHikeDetails
// mutation; on success it reloads so the page reflects the new name/description/
// difficulty/visibility.
import { ref, onMounted } from 'vue'
import EditHikeDetailsModal from '../hikes/components/EditHikeDetailsModal.vue'
import graph_client from '../../utils/graphql/graph_client'
import { UpdateHikeDetails } from '../../utils/graphql/hikes-graph'

const hike = ref(window.editHikeDetailsData || null)
const modal = ref(null)

onMounted(() => {
  // Exposed so the ERB "Edit Details" menu item can open the modal.
  window.openEditHikeDetails = () => modal.value?.show()
})

async function saveHikeDetails (formData, { done, fail }) {
  const current = hike.value
  if (!current?.id) return fail('No hike selected')

  try {
    const result = await graph_client.request(UpdateHikeDetails, {
      input: {
        id: current.id,
        name: formData.name,
        description: formData.description,
        difficulty: formData.difficulty,
        publiclyVisible: formData.publiclyVisible
      }
    })

    const errors = result?.updateHikeDetails?.errors
    if (errors && errors.length > 0) {
      return fail(errors.map(e => e.errors.join(', ')).join('; '))
    }

    done()
    window.location.reload()
  } catch (err) {
    console.error('UpdateHikeDetails failed:', err)
    const msg = err?.response?.errors?.[0]?.message || err?.message || 'Failed to update hike details'
    fail(msg)
  }
}
</script>
